module.exports = __webpack_public_path__ + "static/media/Logo-Swip.44b94b82.svg";